/* eslint-disable import/prefer-default-export */
export const getInnerDisplayName = (name = '') => {
  const lastParenOpenIndex = name.lastIndexOf('(');
  const firstParenCloseIndex = name.indexOf(')');

  return lastParenOpenIndex > -1
    ? name.substring(lastParenOpenIndex + 1, firstParenCloseIndex)
    : name;
};
